import { lazy } from 'react';

const componentLoader = (componentImport) => {
  let pending = null;
  // Starts loading the chunk ahead of rendering (see routes/preloadRoute);
  // the lazy component reuses this request. A failed request is forgotten,
  // so the next attempt loads the chunk again.
  const preload = () => {
    pending ||= componentImport().catch((error) => {
      pending = null;
      throw error;
    });
    return pending;
  };

  const Component = lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('page-has-been-force-refreshed') || '0'
    );

    try {
      const component = await preload();
      window.localStorage.setItem('page-has-been-force-refreshed', '0');
      return component;
    } catch (error) {
      // Vite reports module errors directly; reloading hides the original cause.
      if (import.meta.env.DEV) throw error;

      if (+pageHasAlreadyBeenForceRefreshed < 5) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem(
          'page-has-been-force-refreshed',
          `${+pageHasAlreadyBeenForceRefreshed + 1}`
        );
        return window.location.reload();
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });
  Component.preload = preload;
  return Component;
};

export default componentLoader;
